require('bootstrap-select');
module.exports = {
  updateValidity: function updateValidity() {
    $('.selectpicker').on('changed.bs.select', function () {
      if (this.checkValidity()) {
        $(this).removeClass('is-invalid');
      }
    });
  }
};